// @flow
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  Card,
  Box,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
} from "@material-ui/core";
import {AsyncPaginate} from 'react-select-async-paginate';
import theme from "../../../theme";
import clsx from "clsx";
import { useParams } from "react-router-dom";
import mapStateToRequest from "../../../helpers/mapStateToRequest";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import SnackBar from "../../../components/SnackBar";
import PropTypes from "prop-types";
import { api_get, api_post, api_put } from "../../../utils/Api.js";
import { getPenalties } from "helpers/methods";


const useStyles = makeStyles((theme) => ({
  root: {},
}));

const Form = (props) => {
  const { id } = useParams();
  const { className, edit, ...rest } = props;
  const classes = useStyles();
  const [values, setValues] = useState({
    name: "",
    description: "",
    points: 0,
    number: "",
    penalty: "",
  });
  const [message, setAlertMessage] = useState("");
  const [severity, setAlertSeverity] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (edit) {
      setLoading(true)
      api_get(`penalty-details/${id}`).then((result) => {
        setLoading(false)
        const data = result.payload;
        setValues({
          name: data.name,
          description: data.description,
          points: data.points,
          number: data.number,
          penalty: data.penalty,
        });
      });
    }
  }, [edit, id]);
  
  const handleChange = (event) => {
    event.preventDefault();
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };
  const penaltyChange = (options) => {
    setValues({ ...values, penalty: options,});
  };

  const showErrorMessage = (errors) => {
    Object.keys(errors).map(function(key, index) {
      if (index == 0) {
        setAlertSeverity("error");
        setAlertMessage(errors[key][0]);
        setOpen(true);
      }
    });
  };
  const formValidation = (values) => {
    if (!values.penalty) {
      return { success: false, message: "Penalty type is missing" };
    }
    if (!values.name) {
      return { success: false, message: "Name is missing" };
    }
    if (!values.description) {
      return { success: false, message: "Description is missing" };
    }
  };
  const handleSubmit = () => {
    const requestValues = mapStateToRequest(values);
    setLoading(true);
    const validation = formValidation(requestValues);
    if (validation) {
      setAlertMessage(validation.message);
      setAlertSeverity("warning");
      setOpen(true);
    } else {
      if (props.edit) {
        api_put(`penalty-details/${id}`, requestValues).then((result) => {
          if (result?.errors) {
            showErrorMessage(result.errors);
          } else if (result?.code !== 200 && result?.code !== 201) {
            setAlertSeverity("warning");
            setAlertMessage(
              result?.message
                ? result.message
                : "Technical error! Contact the Developers Team"
            );
            setOpen(true);
          } else {
            setAlertSeverity("success");
            setAlertMessage("Penalty details updated successfully");
            setLoading(false);
            setOpen(true);
            window.location.href = '/teacher-settings/penalty-details';
          }
        });
      } else {
        api_post(`penalty-details`, requestValues)
          .then((result) => {
            if (result?.errors) {
              showErrorMessage(result.errors);
            } else if (result?.code !== 200 && result?.code !== 201) {
              setAlertSeverity("warning");
              setAlertMessage(
                result?.message
                  ? result.message
                  : "Technical error! Contact the Developers Team"
              );
              setOpen(true);
            } else {
              setAlertSeverity("success");
              setAlertMessage("Penalty details created successfully");
              setOpen(true);
              setLoading(false);
              window.location.href = '/teacher-settings/penalty-details';
            }
          })
          .catch((error) => {
            throw new Error(error);
          });
      }
    }
  };

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Card {...rest} className={clsx(classes.root, className)}>
            <form autoComplete="off" noValidate>
              <Divider />
              <CardContent>
                <Grid container spacing={3}>
                <Grid
                    item
                    md={3}
                    xs={12}
                    inputProps={{
                      form: {
                        autocomplete: "off",
                      },
                    }}
                  >
                  <AsyncPaginate
                      loadOptions={getPenalties}
                      value={values.penalty || ''}
                      onChange={penaltyChange}
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.id}
                      placeholder="Penalty"
                      additional={{
                        page: 1,
                      }}
                      styles={{
                        control: (base) => ({
                          ...base,
                          height: '53px',
                        }),
                        placeholder: (base) => ({
                          ...base,
                          color: '#000',
                          fontSize: theme.typography.fontSize,
                          fontFamily: theme.typography.fontFamily,
                        }),
                      }}
                      menuPortalTarget={document.querySelector('body')}
                  />
                  </Grid>
                  <Grid
                    item
                    md={3}
                    xs={12}
                    inputProps={{
                      form: {
                        autocomplete: "off",
                      },
                    }}
                  >
                    <TextField
                      fullWidth
                      autoComplete="none"
                      label="Name"
                      name="name"
                      onChange={handleChange}
                      required
                      value={values.name || ""}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextField
                      fullWidth
                      autoComplete="none"
                      label="Points"
                      name="points"
                      onChange={handleChange}
                      required
                      value={values.points || ""}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextField
                      fullWidth
                      autoComplete="none"
                      label="Number"
                      name="number"
                      onChange={handleChange}
                      required
                      value={values.number || ""}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <TextField
                      fullWidth
                      autoComplete="none"
                      label="Description"
                      name="description"
                      onChange={handleChange}
                      required
                      value={values.description || ""}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </CardContent>
              <Divider />
              <CardActions>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleSubmit}
                >
                  Save details
                </Button>
              </CardActions>
            </form>
      </Card>
      <SnackBar
        open={open}
        message={message}
        severity={severity}
        handleClose={handleClose}
      />
    </div>
  );
};

Form.propTypes = {
  className: PropTypes.string,
  handleCloseLoading: PropTypes.func,
  loading: PropTypes.bool,
};

export default Form;
